import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import Select from "react-select";
import { setSidebarStatus } from "actions/user";
import { RefreshIcon } from "assets/svg-icons";

// Same header as Pricing Catalogs: drawer toggle, page title, the admin's
// company picker, search and refresh.
export const DatabaseHeader = ({
  title,
  workspace,
  searchValue,
  setSearchValue,
  onRefresh,
  confirmLeave,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { isAdmin, companies, selectedCompany, setSelectedCompany } = workspace;

  return (
    <div className="inner-header-position">
      <div className="custom-container d-flex align-items-center justify-content-between flex-wrap">
        <div className="d-flex align-items-center">
          <div
            onClick={() => dispatch(setSidebarStatus(true))}
            className="cursor-pointer"
            data-testid="database-open-drawer"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
              <path
                d="M6.84102 8.825L3.02435 5L6.84102 1.175L5.66602 0L0.666016 5L5.66602 10L6.84102 8.825Z"
                fill="#9E9E9E"
              />
            </svg>
          </div>
          <p className="my-heading f-14 ml-3 mr-3">{title}</p>
          <a
            href="/pricing-catalogues"
            className="f-14 mr-3"
            style={{ whiteSpace: "nowrap" }}
            onClick={(e) => {
              e.preventDefault();
              history.push("/pricing-catalogues");
            }}
          >
            Pricing Catalogs
          </a>
          {isAdmin && (
            <div style={{ minWidth: 250 }}>
              <Select
                onChange={(e) => confirmLeave(() => setSelectedCompany(e))}
                options={companies}
                value={selectedCompany}
                isDisabled={companies.length === 0}
                className="header-select"
                placeholder="Company (BidLight when empty)"
                isClearable
              />
            </div>
          )}
        </div>
        <div className="projActionButtons d-flex flex-wrap" style={{ maxWidth: "100%" }}>
          <input
            type="text"
            className="search-bar"
            value={searchValue}
            onChange={(event) => setSearchValue(event.target.value)}
            placeholder="Search"
          />
          <div className="btn-tool-group">
            <button className="px-3 bg-white text-bid shadow-hover" onClick={onRefresh}>
              <RefreshIcon />
              Refresh
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
